import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--font-apercu-normal%22,%22src%22:%22../../../fonts/apercu-regular.woff2%22,%22display%22:%22swap%22,%22weight%22:%22400%22}],%22variableName%22:%22apercuNormal%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'apercuNormal', 'apercuNormal Fallback'",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
